import { CONTENT } from "../Content";

export default function Home() {
    return <>{ CONTENT }</>;
}
